export default [
    {id:1,label:"Camins del Parc",layers:["camins-geojson-LineString",],visibility:false},
    {id:9,label:"Camins GR i PR",layers:["GR_PR_PNMM",],visibility:false},    
    {id:2,label:"Zones aparcaments",layers:["aparcaments-polygon","aparcaments-point","tanques_vehicle-point","areesdescans-point",],visibility:true},
    {id:3,label:"Conjunt Eremític",layers:["Ermites","Capella"],visibility:false},
    {id:4,label:"Fonts",layers:["Font_B","Font_C_D","Font_CP","Font_DGT","Font_M","Font_R","Font_R_X"],visibility:false},
    {id:5,label:"Coves",layers:["Coves"],visibility:false},
    {id:6,label:"Refugis i Acampada",layers:["refugis", "ZonaAcampada"],visibility:false},
    {id:7,label:"Punts d'interès",layers:["PuntsInteres"],visibility:false},
    {id:8,label:"Límits del Parc",layers:["limits-geojson-polygon","limits-point"],visibility:false}, 
]
